
import './js/modal.js'
import './js/product-slider.js'